export default __webpack_public_path__ + "static/media/google-share-1-tw.3c2a4ed8.jpeg";